import { makeStyles } from '@mui/styles';
import config from 'config';
import { defaultTheme } from '../../styles';
import landingHeaderImage from '../../assets/ra-ui-desktop-lighter.png';

const useStyles = makeStyles(() => {
	return {
		topBar: {
			// backgroundColor: defaultTheme.palette.primary.main,
			// background: 'linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(255,255,255,0) 100%)',
			backgroundColor:'#000000',
			background: 'none',
			boxShadow: 'none',
		},
		bottomBar: {
			top: 'auto',
			bottom: 0,
			flexFlow: 'row',
			backgroundColor: '#001010',
			position: 'fixed',
		},
		actionButton: {
			margin: 'auto',
		},
		appContainer: {
			display: 'flex',
			flexGrow: 1,
			backgroundImage: `linear-gradient(180deg, #000000bb, #ffffff00), url(${landingHeaderImage})`,
			backgroundSize: 'cover',
			backgroundPosition: 'center',
			backgroundAttachment: 'fixed',
			marginTop: -64,
		},
		title: {
			flexGrow: 1,
			color: 'white',
			textDecoration: 'none',
		},
		navLogo: {
			height: config.ui.navLogoHeight || 34,
		},
	};
});
export default useStyles;
